// 改派 营销员 电商专员 云客服
import React, {useState, useEffect} from 'react'
import request, {METHODS} from '@/api'
import {Row, Col, ConfigProvider, Button, Form, Input, Select, Table, message} from 'antd'
import {SCommonDialog, SFuncModal} from 'shj-components'
import zhCN from 'antd/lib/locale/zh_CN'
import {isEmpty} from 'lodash-es'
import track from '@/utils/track'
import {queryCallUser, queryEcommerce} from '@/services/publicInformation'
import dayjs from 'dayjs'
import UrlConfig from '@/api/UrlConfigs'
import {getEmployee} from "@/services/customerServices.ts";

const {Option} = Select

function ServiceEdit1(props: any) {
  const {id, type, onClose, ids, buttonKey, fn, listRef} = props
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState([])
  const [filterList, setFilterList] = useState<any[]>([])
  const [searchData, setSearchData] = useState<any>({name: 'userName', input: ''})
  const [select, setSelect] = useState<Record<string, any> | undefined>()
  const onFinish = () => {
    if (!select) {
      message.error(`请选择一个${type}`)
      return
    }
    setLoading(true)
    let url = ''
    let _data: Record<string, any> = {}
    switch (type) {
      case '云客服':
        url = UrlConfig.Clue.ReassigClue
        _data = {
          clueIds: ids ? ids : [id],
          workerNumber: select.workNumber,
          name: select.workName,
          departPosCode: select.positionCode,
          departPosName: select.positionName,
          deptCode: select.deptCode,
          deptName: select.deptName,
          companyCode: select.companyCode,
          companyName: select.companyName,
        }
        break
      case '电商专员':
        url = UrlConfig.Clue.ReassignElectric
        _data = {
          ids: ids ? ids : [id],
          clueRelatives: {
            workerNumber: select.workNumber,
            name: select.workName,
            departPosCode: select.positionCode,
            departPosName: select.positionName,
            deptCode: select.deptCode,
            deptName: select.deptName,
            companyCode: select.companyCode,
            companyName: select.companyName,
          },
        }
        break
      case '数智轻奢装营销员':
        url = UrlConfig.Clue.DispatchForLuxury
        _data = {
          clueId: id,
          workerNumber: select.workNumber,
          name: select.workName,
          departPosCode: select.positionCode,
          departPosName: select.positionName,
          deptCode: select.deptCode,
          deptName: select.deptName,
          companyCode: select.companyCode,
          companyName: select.companyName,
          buttonKey: buttonKey,
        }
        break;
      case '营销员':
          url = UrlConfig.PlusCrmWeb.SalesSeaBatchDispatch
          _data = {
            [ids ? 'clueIds' : 'clueId']: ids ? ids : id,
            relatives: {
              name: select.userName,
              ucenterUserId: select.ucenterUserId,
              deptId: select.orgId,
              companyId: select.companyId,
              roleCode: select.roleCode,
            },
          }
        break
      default:
        break
    }
    request(url, {
      method: METHODS.POST,
      data: _data,
    })
      .then(() => {
        message.success('操作成功')
        listRef && listRef.current.reload()
        fn && fn()
        onClose()
      })
      .finally(() => {
        setLoading(false)
      })
  }
  const change = (v: any, name: string) => {
    const _data = {...searchData}
    if (name == 'input') {
      _data[name] = v.target.value
    } else {
      _data[name] = v
    }
    setSearchData(_data)
  }
  const search = () => {
    const _list = list.filter((item: any) => {
      if (item[searchData.name] && item[searchData.name]?.indexOf(searchData.input) != -1 || !searchData.input) return item
    })
    setFilterList(_list)
  }
  useEffect(() => {
    console.log(type,111)
    setLoading(true);
    switch (type) {
      case '云客服':
        queryCallUser().then((resp: any) => {
          setList(resp.list)
          setFilterList([...resp.list])
        }).finally(() => {
          setLoading(false)
        })
        break
      case '电商专员':
        queryEcommerce(id).then((resp: any) => {
          setList(resp.list)
          setFilterList([...resp.list])
        }).finally(() => {
          setLoading(false)
        })
        break
      case '数智轻奢装营销员':
      case '营销员':
        getEmployee({ queryEmployee: true, queryOrg: true, pageSize: 99999 }).then((resp: any) => {
          setList(resp.list)
          setFilterList([...resp.list])
        }).finally(() => { setLoading(false) })
        break
      default:
        break
    }
  }, [])
  return (
      <SFuncModal.Content
        confirmLoading={loading}
        onCancel={onClose}
        onOk={onFinish}
      >
        <Form>
          <Row style={{marginBottom: 10}}>
            <Col span={12}>
              {`新${type}: ` +
                  (select ? select.orgNamePath + '-' + select.userName : '')}
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={4}>
              <Form.Item>
                <Select
                    onChange={v => {
                      change(v, 'name')
                    }}
                    value={searchData.name}
                >
                  <Option value="userName">姓名</Option>
                  <Option value="userPhone">电话</Option>
                  <Option value="orgNamePath">部门</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item>
                <Input
                    onChange={v => {
                      change(v, 'input')
                    }}
                    value={searchData.input}
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Button
                  type="primary"
                  style={{marginRight: 10}}
                  onClick={() => {
                    search()
                  }}
              >
                查询
              </Button>
              <Button
                  onClick={() => {
                    setSearchData({name: 'userName', input: ''})
                    setFilterList(list)
                  }}
              >
                重置
              </Button>
            </Col>
          </Row>
          <Table
              rowSelection={{
                type: 'radio',
                onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
                  // const _list = [...tableSelect];
                  // _list[index] = selectedRows[0];
                  // setTableSelect(_list);
                  setSelect(selectedRows[0])
                },
              }}
              scroll={{y: 350}}
              dataSource={filterList}
              rowKey="id"
              loading={loading}
              columns={[
                {title: '姓名', dataIndex: 'userName'},
                {title: '电话', dataIndex: 'userPhone'},
                // {title: '工号', dataIndex: 'workNumber'},
                // {title: '公司', dataIndex: 'companyName'},
                {title: '部门', dataIndex: 'orgNamePath'},
                {title: '职位', dataIndex: 'roleName'},
              ]}
          />
        </Form>
      </SFuncModal.Content>
  )
}

export function clueServiceEdit(props: any) {
  const {id, type, ids, buttonKey, fn, listRef, onclose} = props
  if (!isEmpty(props.trackParams)) {
    track('task_page_view', {
      enter_time: dayjs().format('yyyy-MM-DD HH:mm:ss'),
      ...props.trackParams,
    })
  }
  const onClose = () => {
    if (!isEmpty(props.trackParams)) {
      track('task_page_close', {
        leave_time: dayjs().format('yyyy-MM-DD HH:mm:ss'),
        ...props.trackParams,
      })
    }
    onclose && onclose()
    dialog.destroy()
  }
  const dialog = SFuncModal({
    title: type == '营销员' && ids ? `分配营销员` : `改派${type}`,
    width: 1000,
    vanish: true,
    content: (
        <ConfigProvider locale={zhCN}>
          <ServiceEdit1
              onClose={onClose}
              ids={ids}
              id={id}
              type={type}
              buttonKey={buttonKey}
              fn={fn}
              listRef={listRef}
          />
        </ConfigProvider>
    ),
  })

  return dialog
}
